<div class="recipes">
  <div class="filter">
    <div class="options">
      <div class="dropdown" dropdown [reactive]="true">
        <button>Categories</button>
        <div class="dropmenu">
          <button (click)="filter('categories', 'pizza')">Pizza</button>
          <button (click)="filter('categories', 'burger')">Burger</button>
          <button (click)="filter('categories', 'salad')">Salad</button>
          <button (click)="filter('categories', 'noodles')">Noodles</button>
          <button (click)="filter('categories', 'fried_rice')">
            Fried rice
          </button>
          <button (click)="filter('categories', 'soup')">Soup</button>
          <button (click)="filter('categories', 'juice')">Juice</button>
          <button id="Categories" (click)="filter('categories', 'clear')">Clear</button>
        </div>
      </div>
      <div class="dropdown" dropdown>
        <button>Portion</button>
        <div class="dropmenu">
          <button>For 1</button>
          <button>For 2</button>
          <button>For 3</button>
          <button>For 4</button>
          <button>For 5</button>
          <button>For 5+</button>
        </div>
      </div>
      <div class="dropdown" dropdown>
        <button>Calories</button>
        <div class="dropmenu">
          <button>< 50 cal</button>
          <button>< 100 cal</button>
          <button>< 150 cal</button>
          <button>< 200 cal</button>
          <button>< 250 cal</button>
          <button>< 300 cal</button>
          <button>< 350 cal</button>
          <button>< 400 cal</button>
          <button>> 400 cal</button>
        </div>
      </div>
      <div class="dropdown" dropdown>
        <button>Time</button>
        <div class="dropmenu">
          <button>< 10 mins</button>
          <button>< 20 mins</button>
          <button>< 30 mins</button>
          <button>< 40 mins</button>
          <button>< 50 mins</button>
          <button>< 60 mins</button>
          <button>> 60 mins</button>
        </div>
      </div>
      <div class="dropdown" dropdown>
        <button>Sort by</button>
        <div class="dropmenu">
          <button>Lastest</button>
          <button>Popular</button>
        </div>
      </div>
    </div>
    <div class="search">
      <div class="wrapper">
        <input type="text" placeholder="Eg. pizza, sushi" />
        <button class="mainBtn black">Search</button>
      </div>
    </div>
  </div>
  <div class="content">
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/pizza.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Cheese Pizza</div>
          <div class="calories">14 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>45 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>3 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/juice.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">New York Cheesecake Recipe</div>
          <div class="calories">33 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>32 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>1 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/burger.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Baked Chicken Burgers Recipe</div>
          <div class="calories">25 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>25 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>5 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/fried_rice.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Unique Chicken Biryani Recipe</div>
          <div class="calories">42 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>55 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>2 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/pizza.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Cheese Pizza</div>
          <div class="calories">14 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>45 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>3 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/juice.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">New York Cheesecake Recipe</div>
          <div class="calories">33 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>32 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>1 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/burger.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Baked Chicken Burgers Recipe</div>
          <div class="calories">25 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>25 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>5 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/fried_rice.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Unique Chicken Biryani Recipe</div>
          <div class="calories">42 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>55 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>2 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/pizza.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Cheese Pizza</div>
          <div class="calories">14 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>45 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>3 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/juice.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">New York Cheesecake Recipe</div>
          <div class="calories">33 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>32 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>1 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/burger.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Baked Chicken Burgers Recipe</div>
          <div class="calories">25 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>25 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>5 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
    <button routerLink="/111/aaa" class="recipeCard">
      <div class="cover">
        <img src="assets/categories/fried_rice.jpg" alt="" />
      </div>
      <div class="wrapper">
        <div class="info">
          <div class="name">Unique Chicken Biryani Recipe</div>
          <div class="calories">42 calories</div>
        </div>
        <div class="meta">
          <div>
            <div>Time</div>
            <div>55 mins</div>
          </div>
          <div>
            <div>Portion</div>
            <div>2 persons</div>
          </div>
        </div>
        <div class="counts">
          <div class="likes"><ion-icon name="heart-outline"></ion-icon> 92</div>
          <div class="chat">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon> 11
          </div>
          <div class="ratings">
            <ion-icon name="star-outline"></ion-icon> 203
          </div>
        </div>
      </div>
    </button>
  </div>
</div>
